module.exports = __webpack_public_path__ + "static/media/13-RPEX6.e07245a4.jpg";